import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import type { CompInfo } from '@wix/thunderbolt-components-native';
import { getFromColorMap } from '@wix/thunderbolt-commons/dist/color';
import type {
  TextMaskCSSVars,
  TextMaskDataProps,
  TextMaskDefinition,
  TextMaskPropsCarmiProps,
} from '../TextMask.types';
import { TranslationKeys } from '../constants';

export const props = withCompInfo<
  TextMaskDataProps,
  TextMaskDefinition,
  TextMaskPropsCarmiProps
>()(
  ['compData', 'siteColors', 'translate'],
  (
    { compData, translate }: Partial<CompInfo> & { translate: any },
    carmiProps,
  ) => {
    const { fillLayers, ...design } = carmiProps || {};
    const viewBox = design.isThemeFont ? '0 0 0 0' : design.viewBox;

    return {
      ...compData,
      ...design,
      viewBox,
      fillLayers,
      translations: {
        ariaLabel: translate(
          TranslationKeys.namespace,
          TranslationKeys.ariaLabel,
        ),
        pauseLabel: translate(
          TranslationKeys.namespace,
          TranslationKeys.pauseLabel,
        ),
        playLabel: translate(
          TranslationKeys.namespace,
          TranslationKeys.playLabel,
        ),
      },
    };
  },
);

export const css = withCompInfo<TextMaskCSSVars, TextMaskDefinition>()(
  ['compDesign', 'siteColors'],
  (
    { compDesign, siteColors }: Partial<CompInfo>,
    carmiCssVars: any,
  ): TextMaskCSSVars => {
    const { shadow } = compDesign;
    const resolveColor = (color: string) => getFromColorMap(color, siteColors);
    const hasShadow = shadow && Object.keys(shadow).length > 0;
    const shadowFilter = hasShadow
      ? `drop-shadow(${shadow.x}px ${shadow.y}px ${
          shadow.blurRadius
        }px ${resolveColor(shadow.color)}${Math.round(
          shadow.opacity * 255,
        ).toString(16)})`
      : 'none';
    return {
      ...carmiCssVars,
      height: 'auto',
      '--shadow-filter': shadowFilter,
    };
  },
);

export default createComponentMapperModel({ css, props });
